import { useEffect, useRef, useState } from "react";
import Layout from "../components/Layout";
import PromptCard from "../components/PromptCard";
import ShareButton from "../components/ShareButton";
import DownloadImageButton from "../components/DownloadImageButton";
import { api } from "../lib/api";
import { toast } from "sonner";

const COLOR = "#FFB000";

const QueDibujo = () => {
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState("aleatorio");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const cardRef = useRef(null);

  const generate = async (cat = category) => {
    setLoading(true);
    try {
      const res = await api.post("/generate/que-dibujo", { category: cat });
      setData(res.data);
    } catch (e) {
      console.error(e);
      toast.error("Algo falló. Intenta de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let active = true;
    api.get("/categories/que-dibujo").then((r) => {
      if (!active) return;
      const items = r.data?.items || [];
      setCategories(items);
    }).catch(() => {});
    generate("aleatorio");
    return () => { active = false; };
    /* eslint-disable-next-line */
  }, []);

  const d = data?.data || {};

  return (
    <Layout accent={COLOR}>
      <section className="max-w-5xl mx-auto px-5 sm:px-8 pt-10 sm:pt-16">
        <div className="mb-8">
          <span className="inline-block font-mono text-xs uppercase tracking-[0.25em] font-bold bg-[#FFB000] border-4 border-[#1a1a1a] rounded-full px-4 py-1 mb-4">
            tool · 01
          </span>
          <h1 className="font-display font-black text-5xl sm:text-7xl leading-[0.95] tracking-tight mb-4">
            ¿qué dibujo<span className="text-[#FFB000]">?</span>
          </h1>
          <p className="font-mono text-sm sm:text-base text-[#4a4a4a] max-w-xl">
            Elige una temática y la IA te lanza una idea fresca. Si no te gusta, dale a "otra idea".
          </p>
        </div>

        <div className="mb-8 flex flex-wrap gap-2" data-testid="category-list">
          {categories.map((c) => {
            const id = c.toLowerCase();
            return (
              <button
                key={id}
                data-testid={`cat-${id}`}
                onClick={() => { setCategory(id); generate(id); }}
                disabled={loading}
                className={`press font-mono text-xs uppercase tracking-wider font-bold border-4 border-[#1a1a1a] rounded-full px-4 py-2 shadow-hard-sm ${
                  category === id ? "bg-[#FFB000]" : "bg-white"
                }`}
              >
                {c}
              </button>
            );
          })}
        </div>

        {loading && !data && (
          <div className="bg-white border-4 border-[#1a1a1a] rounded-3xl shadow-hard-md p-10 text-center font-mono text-sm uppercase tracking-[0.25em]">
            Pensando...
          </div>
        )}

        {data && (
          <PromptCard
            ref={cardRef}
            color={COLOR}
            eyebrow={`Estilo: ${d.estilo || "libre"}`}
            title={d.titulo || "Una idea misteriosa"}
            subtitle={d.descripcion}
            details={Array.isArray(d.detalles) ? d.detalles : []}
            onRegenerate={() => generate(category)}
            loading={loading}
            testId="que-dibujo-prompt"
            watermark="guango · ¿qué dibujo?"
          >
            <div className="mt-4 flex flex-wrap gap-3" data-exclude-from-image="true">
              <ShareButton promptId={data.id} color={COLOR} testId="que-dibujo-share" />
              <DownloadImageButton
                targetRef={cardRef}
                fileName={`guango-que-dibujo-${data.id.slice(0, 8)}.png`}
                color={COLOR}
                testId="que-dibujo-download"
              />
            </div>
          </PromptCard>
        )}
      </section>
    </Layout>
  );
};

export default QueDibujo;
